import React from 'react';
import { Button, Result } from 'antd';

const Forbidden = () => (
  <Result
    status="403"
    title="403"
    subTitle="No cuentas con permisos suficientes para acceder a este recurso."
    //extra={<Button type="primary">Back Home</Button>}
  />
);

export default Forbidden;